export default "__VITE_ASSET__DLrM3T$D__";